import { render, staticRenderFns } from "./compRoleInfo.vue?vue&type=template&id=07f51c2a&"
import script from "./compRoleInfo.vue?vue&type=script&lang=js&"
export * from "./compRoleInfo.vue?vue&type=script&lang=js&"
import style0 from "./compRoleInfo.vue?vue&type=style&index=0&id=07f51c2a&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07f51c2a')) {
      api.createRecord('07f51c2a', component.options)
    } else {
      api.reload('07f51c2a', component.options)
    }
    module.hot.accept("./compRoleInfo.vue?vue&type=template&id=07f51c2a&", function () {
      api.rerender('07f51c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/components/compRoleInfo.vue"
export default component.exports